import React from 'react'
import PropTypes from 'prop-types'
import { propOr } from 'ramda'
import { useMakeSelector, useSelector } from 'hooks/redux'
import {
  makeGetPinCircuit,
  getShowHarnesses,
} from 'selectors/feature/harnesses'
import { getFunctionOutput } from 'selectors/feature/outputs'

import strings from 'utils/strings'

import ReadOnlyParameterValue from 'components/feature/NavigatorPanes/editors/base/ReadOnlyParameterValue'

import { Container, StyledHoverableInfoIcon } from './Circuit.style'

const Circuit = ({ className, id, outputId }) => {
  // signal/input circuit
  const circuit = useMakeSelector(makeGetPinCircuit, { id })
  // output circuit
  const output = useSelector(getFunctionOutput, { id: outputId })
  const outputFloatingCircuit = propOr(null, 'floatingCircuit', output)
  const showHarnesses = useSelector(getShowHarnesses)
  const showNoFloatingCircuitMessage = !circuit && !outputFloatingCircuit
  const noValueText = id
    ? strings.no_input_available
    : strings.no_input_selected

  return !showHarnesses ? null : (
    <Container>
      <ReadOnlyParameterValue
        className={className}
        label={strings.circuit}
        value={circuit || outputFloatingCircuit}
        noValueText={noValueText}
      />
      {showNoFloatingCircuitMessage && (
        <StyledHoverableInfoIcon tooltip={strings.feature_circuit_tooltip} />
      )}
    </Container>
  )
}

Circuit.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  outputId: PropTypes.string,
  floatingCircuit: PropTypes.string,
}

export default Circuit
